module.exports = __webpack_public_path__ + "img/ifsttar.718a42ae.png";